import { LOCALE, CURRENCY_LONG, CURRENCY_SHORT } from "utilities/global.variables";

export const formatCurrency = (value) => new Intl.NumberFormat(LOCALE, CURRENCY_LONG).format(value);


export const formatCurrencyCompact = (value, decimals = 0) =>
  new Intl.NumberFormat(LOCALE, {
    ...CURRENCY_SHORT,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value).replace('K', 'k');

export const formatPercent = (value) => `${new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 }).format(value)}%`;



// PRODUCE DATE: 17 Aug 1983
export const formatDate = (dateString) => {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString(LOCALE, { day: 'numeric', month: 'short', year: 'numeric' });
};



// Staleness check — returns true if date is older than `days` days
export const isOlderThan = (date, days = 30) =>
  (Date.now() - new Date(date).getTime()) / (1000 * 60 * 60 * 24) > days;

// Ownership-adjusted valuation
export const ownedValue = (valuation, ownership) =>
  ownership < 100 ? (ownership * valuation) / 100 : valuation;
